export default __webpack_public_path__ + "static/media/vtex.b7f07433.png";